import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import { getCourseProofsOptions, useDeleteCourseProof, useUploadOrUpdateCourseProof } from './model/CourseProofModel';

interface CourseProofActionProps {
  courseId: number;
  authors: Author[];
  variant?: 'compact';
}

export function CourseProofAction({ courseId, authors }: CourseProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getCourseProofsOptions(courseId));
  const uploadOrUpdateMutation = useUploadOrUpdateCourseProof(courseId);
  const deleteMutation = useDeleteCourseProof(courseId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="course"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
